import PropTypes from "prop-types";
import RtrImage from "components/source/shared/rtr-image";
import FormattingUtils from "helpers/FormattingUtils";

export default function ReviewImagesWithMemberInfo(props) {
  return (
    <>
      {props.reviewsCoverPhotos.map((reviewsCoverPhoto, index) => {
        const isImageInViewport = index < 5;

        const imgSrc = reviewsCoverPhoto.hasCroppedPhoto
          ? reviewsCoverPhoto?.coverPhoto?.urls?.imageCropped
          : reviewsCoverPhoto?.coverPhoto?.urls?.image;

        const heightInFeet = Number.isInteger(reviewsCoverPhoto?.reviewerSnapshot?.heightInches)
          ? FormattingUtils.formatHeight(reviewsCoverPhoto?.reviewerSnapshot?.heightInches)
          : "";

        const sizeWorn =
          reviewsCoverPhoto?.sizeWorn && reviewsCoverPhoto?.sizeWorn !== "NONE"
            ? `wearing size ${reviewsCoverPhoto?.sizeWorn}`
            : "";

        const memberReviewInfo = sizeWorn || heightInFeet ? `Member is ${heightInFeet} ${sizeWorn}` : ``;

        return (
          <div
            key={reviewsCoverPhoto?.reviewId}
            className="featured-review-image-carousel__child snap-start"
            data-test-id="featured-review-image-carousel__child">
            <RtrImage
              alt={`review featured images ${index}`}
              itemProp={"image"}
              src={imgSrc}
              loading={isImageInViewport ? "eager" : "lazy"}
              sizes={"(max-width: 480px) 80vw, (max-width: 1024px) 50vw, 1080px"} // ideally the browser would use src as a default if the srcset media width doesn't match, but it's not always smart enough so specificying a size for 1080 here
            />
            {memberReviewInfo && (
              <p className="featured-review-image-carousel__child__floating-text">{memberReviewInfo}</p>
            )}
          </div>
        );
      })}
    </>
  );
}

ReviewImagesWithMemberInfo.propTypes = {
  reviewsCoverPhotos: PropTypes.arrayOf(PropTypes.object).isRequired,
};
